import { createCustomIcon } from '@luminovo/design-system';

const STATUS_COLORS = { success: '#02BE9E', warning: '#F9B686', error: '#FA6B7E' };

type PillStatus = keyof typeof STATUS_COLORS;

// The second dot sits 20 units right of the first: a pill with an arrow is 20 units wider.
const FIRST_DOT =
    'M16 11C16 12.6569 14.6569 14 13 14C11.3431 14 10 12.6569 10 11C10 9.34315 11.3431 8 13 8C14.6569 8 16 9.34315 16 11Z';
const ARROW =
    'M23.4999 12.8083C23.4499 12.7583 23.4249 12.6986 23.4249 12.6292C23.4249 12.5597 23.4471 12.5028 23.4916 12.4583L24.7166 11.2333H20.5833C20.511 11.2333 20.4513 11.2097 20.4041 11.1625C20.3569 11.1153 20.3333 11.0556 20.3333 10.9833C20.3333 10.9111 20.3569 10.8514 20.4041 10.8042C20.4513 10.7569 20.511 10.7333 20.5833 10.7333H24.7166L23.4833 9.49999C23.4333 9.44999 23.4096 9.39166 23.4124 9.32499C23.4152 9.25833 23.4416 9.19999 23.4916 9.14999C23.5416 9.10555 23.6013 9.08333 23.6708 9.08333C23.7402 9.08333 23.7971 9.10555 23.8416 9.14999L25.4999 10.8083C25.5277 10.8361 25.5471 10.8639 25.5583 10.8917C25.5694 10.9194 25.5749 10.95 25.5749 10.9833C25.5749 11.0167 25.5694 11.0472 25.5583 11.075C25.5471 11.1028 25.5277 11.1306 25.4999 11.1583L23.8499 12.8083C23.7999 12.8583 23.7416 12.8833 23.6749 12.8833C23.6083 12.8833 23.5499 12.8583 23.4999 12.8083Z';
const SECOND_DOT =
    'M36 11C36 12.6569 34.6569 14 33 14C31.3431 14 30 12.6569 30 11C30 9.34315 31.3431 8 33 8C34.6569 8 36 9.34315 36 11Z';

/** A status pill, as a Lucide icon: `size` sets its height (22px by default) and the width keeps the ratio. */
function statusPill(displayName: string, status: PillStatus, changedTo?: PillStatus) {
    const width = changedTo === undefined ? 26 : 46;
    return createCustomIcon(displayName, {
        width,
        height: 22,
        strokeWidth: 1,
        ownColors: true,
        render: ({ stroke }) => (
            <>
                <path d={FIRST_DOT} fill={STATUS_COLORS[status]} />
                {changedTo !== undefined && (
                    <>
                        <path d={ARROW} fill="#676D7E" />
                        <path d={SECOND_DOT} fill={STATUS_COLORS[changedTo]} />
                    </>
                )}
                <rect x="0.5" y="0.5" width={width - 1} height="21" rx="10.5" stroke="#E9ECF4" {...stroke} />
            </>
        ),
    });
}

export const SolutionStatusSuccessIcon = statusPill('SolutionStatusSuccess', 'success');
export const SolutionStatusWarningIcon = statusPill('SolutionStatusWarning', 'warning');
export const SolutionStatusErrorIcon = statusPill('SolutionStatusError', 'error');
export const SolutionStatusSuccessToWarningIcon = statusPill('SolutionStatusSuccessToWarning', 'success', 'warning');
export const SolutionStatusSuccessToErrorIcon = statusPill('SolutionStatusSuccessToError', 'success', 'error');
export const SolutionStatusWariningToSuccessIcon = statusPill('SolutionStatusWariningToSuccess', 'warning', 'success');
export const SolutionStatusWariningToErrorIcon = statusPill('SolutionStatusWariningToError', 'warning', 'error');
export const SolutionStatusErrorToSuccessIcon = statusPill('SolutionStatusErrorToSuccess', 'error', 'success');
export const SolutionStatusErrorToWarningIcon = statusPill('SolutionStatusErrorToWarning', 'error', 'warning');
